module.exports = __webpack_public_path__ + "img/chat-write.c868224b.svg";